<template>
  <div>
    <img class="fixed" src="/mops.jpg" />
  </div>
</template>

<script>

export default {
  name: 'four',
  mounted () {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Logic/6Six/index.vue